<div *ngIf="widget.widgetLabel">
    {{widget.widgetLabel ?? ''}}</div>
<div *ngIf="widget.widgetConfig?.dataListWidgetConfig?.headertype === databoardHeaderTypes.custom">
    {{widget.widgetConfig?.dataListWidgetConfig?.customHeader}}</div>
<table *ngIf="loadTable" mat-table [dataSource]="widget.widgetConfig['apiResponce']">
    @if(widget.widgetConfig?.dataListWidgetConfig?.headertype === databoardHeaderTypes.generic ){
    <tr mat-header-row *matHeaderRowDef="updatedTableHeaders"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: updatedTableHeaders;"></tr>
    <ng-container matColumnDef="position" *ngIf="widget.widgetConfig.additionalConfig.serialNumber">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
    </ng-container>
    @for (item of updatedTableHeaders; track $index) {
    <ng-container [matColumnDef]="item" *ngIf="item !== 'position'">
        
            <th mat-header-cell *matHeaderCellDef>
                @if(customTableHeaders.length > 0 && customTableHeaders[$index]?.original === item && customTableHeaders[$index].custom !== ''){
                   {{ customTableHeaders[$index].custom }}
                }@else{
                   {{ item | titlecase }} 
                }
                </th>
        <td mat-cell *matCellDef="let element"  [ngClass]="{'text-primary text-decoration-underline': $index === highlightIndex}" class="text-break"> {{element[item] ?? 0}} </td>
    </ng-container>
    }
</table>